var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllAssignedStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8564 8L14 0L0.143555 8V24L14 32L27.8564 24V8ZM15.25 5.83494L14 5.11325L12.75 5.83494L5.82176 9.83494L4.57176 10.5566V12V20V21.4434L5.82176 22.1651L12.75 26.1651L14 26.8868L15.25 26.1651L22.1782 22.1651L23.4282 21.4434V20V12V10.5566L22.1782 9.83494L15.25 5.83494ZM9.57176 13.4434L14 10.8868L18.4282 13.4434V18.5566L14 21.1132L9.57176 18.5566V13.4434Z",
    fill: "#DFF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAssignedStudents);
export default __webpack_public_path__ + "static/media/all-assigned-students.dc63e14d5a3ce6cb709ae770be9e50aa.svg";
export { ForwardRef as ReactComponent };